//Vivoavulso

//Header
export const backgroundHeaderMobile = '#609';
export const backgroundHeader = '#609';
export const widthLogoDesktop = '120px';
export const widthLogoMobile = '100px';
export const filterLogoHeader =
	'invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(1000%) contrast(1000%)';

// Form Button
export const colorBtnAddSubscriberBtnBackFormButton = '#609';
export const backgroundBtnFowardFormButton = '#609';
export const borderBtnBackFormButton = '#609';
export const backgroundBtnAddSubscriberFormButton = '#609'; // Adicionar Titular
export const colorBtnAddSubscriberkFormButton = 'white';
export const colorBtnAdvanceFormButton = 'white';
export const backgroundBtnAdvanceFormButton = '#609';
export const borderBtnAdvanceFormButton = '#609';
export const colorBorderBtn = '#609';
export const colorBorderBtnHover = '#4d0073';
export const colorBackgroundChecked = '#609';

// Order Resume
export const colorTdOrderResume = '#609';
export const colorH2H4AnchorIconContainerOrderResume = '#609';
export const borderOrderResume = '#609';
export const backgroundApplyButtonOrderResume = '#609';

// StepCounter (progress bar)
export const textSpanTimeLine = '#609';

// Form Wrapper
export const borderTitularDepende = '#609';

// Subscriber Title
export const colorTitleSubscriber = '#609';
export const fontSizeTitleSubscriber = '30px';
export const fontWeightTitleSubscriber = '500';

// Subscribers list Title
export const colorTitleListSubscribers = '#609';
export const fontSizeTitleListSubscribers = '24px';
export const fontWeightTitleListSubscribers = '500';

// Subscribers list
export const colorListSubscribersFaRegEdit = '#609';

// Payment Title
export const colorTitlePayment = '#609';

// Payment Nav-tab
export const backgroundNavActivePayment = '#609';

//Container
export const backgroundContainer = 'none';
